export const data = {
  products: [
    {
      id: 'dress1',
      image: '/Img/shop/1.jpg',
      title: 'Midi sundress with shirring detail',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'XL', 'XXL'],
      colors: ['#ff0000', '#00ff00', '#0000ff'],
      star: 1.8,
      price: 3,
    },
    {
      id: 'dress2',
      image: '/Img/shop/2.jpg',
      title: 'Midi sundress with ruched front',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M', 'L'],
      colors: ['#000', '#ffb900'],
      star: 4,
      price: 25.5,
    },
    {
      id: 'dress3',
      image: '/Img/shop/3.jpg',
      title: 'dress in polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M', 'XL', 'XXL'],
      colors: ['#ffb900', '#0000ff'],
      star: 2.6,
      price: 6.3,
    },
    {
      id: 'dress4',
      image: '/Img/shop/4.jpg',
      title: 'cami maxi dress in polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XL'],
      colors: ['#000', '#00ff00', '#0000ff'],
      star: 3.4,
      price: 6.3,
    },
    {
      id: 'dress5',
      image: '/Img/shop/5.jpg',
      title: 'Frill mini dress in yellow polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'XL'],
      colors: ['#000'],
      star: 4.4,
      price: 45,
    },
    {
      id: 'dress6',
      image: '/Img/shop/6.jpg',
      title: 'Midi tea dress in blue and red spot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XL', 'XXL'],
      colors: ['#00ff00', '#0000ff', '#ff0000'],
      star: 4.8,
      price: 67.8,
    },
    {
      id: 'dress7',
      image: '/Img/shop/7.jpg',
      title: 'yellow polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XXL', 'XL'],
      colors: ['#0000ff', '#000'],
      star: 2,
      price: 97.3,
    },
    {
      id: 'dress8',
      image: '/Img/shop/8.jpg',
      title: 'Frill blue polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M'],
      colors: ['#000', '#ff0000'],
      star: 4,
      price: 18.5,
    },
    {
      id: 'dress9',
      image: '/Img/shop/9.jpg',
      title: 'Green polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'M'],
      colors: ['#000', '#00ff00'],
      star: 4.5,
      price: 38.3,
    },
    {
      id: 'dress10',
      image: '/Img/shop/10.jpg',
      title: 'Fri brown polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'XXL'],
      colors: ['#ff0000', '#ffb900', '#00ff00'],
      star: 3,
      price: 71.1,
    },
    {
      id: 'dress11',
      image: '/Img/shop/11.jpg',
      title: 'Midi sundress with shirring detail',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XXL'],
      colors: ['#00ff00', '#0000ff'],
      star: 1.4,
      price: 32,
    },
    {
      id: 'dress12',
      image: '/Img/shop/12.jpg',
      title: 'Midi sundress with ruched front',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M', 'L'],
      colors: ['#ffb900', '#ff0000', '#00ff00'],
      star: 2.7,
      price: 21.5,
    },
    {
      id: 'dress13',
      image: '/Img/shop/13.jpg',
      title: 'Midi dress in pink ditsy floral',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M', 'XXl'],
      colors: ['#000'],
      star: 2,
      price: 10.2,
    },
    {
      id: 'dress14',
      image: '/Img/shop/14.jpg',
      title: 'cami maxi dress in polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XL'],
      colors: ['#00ff00'],
      star: 3.4,
      price: 9,
    },
    {
      id: 'dress15',
      image: '/Img/shop/15.jpg',
      title: 'Frill mini dress in yellow polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'XL'],
      colors: ['#0000ff'],
      star: 3,
      price: 40,
    },
    {
      id: 'dress16',
      image: '/Img/shop/16.jpg',
      title: 'Midi tea dress in blue and red spot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XXL'],
      colors: ['#00ff00', '#ffb900'],
      star: 3,
      price: 19.8,
    },
    {
      id: 'dress17',
      image: '/Img/shop/17.jpg',
      title: 'yellow polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XXL', 'XL'],
      colors: ['#ffb900'],
      star: 4.4,
      price: 87.3,
    },
    {
      id: 'dress18',
      image: '/Img/shop/18.jpg',
      title: 'Frill blue polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M'],
      star: 5,
      colors: ['#ff0000', '#00ff00'],
      price: 55.9,
    },
    {
      id: 'dress19',
      image: '/Img/shop/19.jpg',
      title: 'Green polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XL', 'M'],
      colors: ['#ff0000'],
      star: 1,
      price: 78.3,
    },
  ],
  comments: [
    {
      id: '1',
      body: 'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      username: 'liza',
      userId: '1',
      parentId: null,
      avatar: '/Img/comment/4.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: '2',
      body: 'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS.',
      username: 'hadi',
      userId: '2',
      parentId: null,
      avatar: '/Img/comment/2.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: '3',
      body: 'First comment first child',
      username: 'elen',
      userId: '2',
      parentId: '1',
      avatar: '/Img/comment/1.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: '4',
      body: 'ipsum dolor sit amet, consectetur adipisicing elit. Nobis aut',
      username: 'merlin',
      userId: '2',
      parentId: '2',
      avatar: '/Img/comment/5.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: '5',
      body: 'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      username: 'ali',
      userId: '2',
      parentId: '4',
      avatar: '/Img/comment/6.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: '6',
      body: 'Fourth comment second child',
      username: 'jolia',
      userId: '2',
      parentId: '1',
      avatar: '/Img/comment/7.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: '7',
      body: 'Fourth comment second child',
      username: 'jo',
      userId: '2',
      parentId: '1',
      avatar: '/Img/comment/2.jpg',
      createdAt: '2021-08-16T23:00:33.010+02:00',
    },
    {
      id: 'f59c0be0-fd4d-4a44-ad73-aadb4ad1d5d4',
      body: 'to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created',
      username: 'mendy',
      userId: '2',
      parentId: '6',
      children: [],
      avatar: '/static/media/comment2.7265f534e120763a918f.jpg',
      createdAt: '2022-06-23T07:52:16.402Z',
    },
    {
      id: '663c73a3-36c0-4388-b3fe-f66b747e47f2',
      body: 'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      username: 'mendy',
      userId: '2',
      parentId: '5',
      children: [],
      avatar: '/static/media/comment2.7265f534e120763a918f.jpg',
      createdAt: '2022-06-23T10:20:01.634Z',
    },
    {
      id: '973b8571-9248-42e2-b65a-ae7aa361fa0c',
      body: 'test content',
      username: 'ali akbar',
      userId: '2',
      parentId: null,
      children: [],
      avatar: '/static/media/comment2.7265f534e120763a918f.jpg',
      createdAt: '2022-06-26T14:20:52.594Z',
    },
    {
      id: '512a1c1e-8d7d-4688-9189-6f29b1155a65',
      body: 'hello world',
      username: 'mendy',
      userId: '2',
      parentId: '973b8571-9248-42e2-b65a-ae7aa361fa0c',
      children: [],
      avatar: '/static/media/comment2.7265f534e120763a918f.jpg',
      createdAt: '2022-06-26T14:21:07.504Z',
    },
    {
      id: 'e7a20caa-075d-4197-9b3b-d705c39d877f',
      body: 'hello',
      username: 'mendy',
      userId: '2',
      parentId: '5',
      children: [],
      avatar: '/static/media/comment2.7265f534e120763a918f.jpg',
      createdAt: '2022-06-26T14:22:08.997Z',
    },
    {
      id: 'eac16593-1a02-48f0-98c8-8756af701388',
      body: 'hello',
      username: 'mendy',
      userId: '2',
      parentId: '3',
      children: [],
      avatar: '/static/media/comment2.7265f534e120763a918f.jpg',
      createdAt: '2022-07-07T18:42:43.714Z',
    },
  ],
  cartItems: [
    {
      id: 'dress1L00ff00',
      title: 'Midi sundress with shirring detail',
      image: '/Img/shop/1.jpg',
      price: 3,
      count: 5,
      size: 'L',
      color: '#00ff00',
    },
    {
      id: 'dress1Lff0000',
      title: 'Midi sundress with shirring detail',
      image: '/Img/shop/1.jpg',
      price: 3,
      count: 2,
      size: 'L',
      color: '#ff0000',
    },
    {
      id: 'dress3XXL0000ff',
      title: 'dress in polka dot',
      image: '/Img/shop/3.jpg',
      price: 6.3,
      count: 3,
      size: 'XXL',
      color: '#0000ff',
    },
    {
      id: 'dress5L000',
      title: 'Frill mini dress in yellow polka dot',
      image: '/Img/shop/5.jpg',
      price: 45,
      count: 5,
      size: 'L',
      color: '#000',
    },
  ],
  wishList: [
    {
      id: 'dress7',
      image: '/Img/shop/7.jpg',
      title: 'yellow polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XXL', 'XL'],
      colors: ['#0000ff', '#000'],
      price: 97.3,
    },
    {
      id: 'dress10',
      image: '/Img/shop/10.jpg',
      title: 'Fri brown polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'XXL'],
      colors: ['#ff0000', '#ffb900', '#00ff00'],
      star: 3,
      price: 71.1,
    },
  ],
  compare: [
    {
      id: 'dress14',
      image: '/Img/shop/14.jpg',
      title: 'cami maxi dress in polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['XL'],
      colors: ['#00ff00'],
      star: 3.4,
      price: 9,
    },
    {
      id: 'dress13',
      image: '/Img/shop/13.jpg',
      title: 'Midi dress in pink ditsy floral',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M', 'XXl'],
      colors: ['#000'],
      star: 2,
      price: 10.2,
    },
    {
      id: 'dress3',
      image: '/Img/shop/3.jpg',
      title: 'dress in polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['M', 'XL', 'XXL'],
      colors: ['#ffb900', '#0000ff'],
      star: 2.6,
      price: 6.3,
    },
    {
      id: 'dress9',
      image: '/Img/shop/9.jpg',
      title: 'Green polka dot',
      description:
        'This is for all the latest trends, no matter who you are, where you’re from and what you’re up to. Exclusive to ASOS, our universal brand is here for you, and comes in all our fit ranges: ASOS Curve, Tall, Petite and Maternity. Created by us, styled by you.',
      availableSizes: ['L', 'M'],
      colors: ['#000', '#00ff00'],
      star: 4.5,
      price: 38.3,
    },
  ],
};
